export const REQUEST_FOR_ESEMINARS = 'REQUEST_FOR_ESEMINARS';
export const GET_ESEMINARS_SUCCESS = 'GET_ESEMINARS_SUCCESS';
export const GET_ESEMINARS_ERROR = 'GET_ESEMINARS_ERROR';
